import { axiosInstance, parseResult } from "./CommonApi";

//공지사항 목록 조회
export const getNoticePostList = async () => {
    const response = await axiosInstance.get(`/main/notice-post/list/`);
    return parseResult(response);
};

//Main Dashboard
export const getDashboardList = async () => {
    const response = await axiosInstance.get(`/main/dashboard/dashboard/`);
    return parseResult(response);
};